"use client";

import { ICategoryFeedResponse } from "@finbackoffice/websocket-client";
import {
    memo,
    forwardRef,
    RefAttributes,
    ForwardRefExoticComponent,
    useCallback,
    useContext,
} from "react";
import FadeInAnimation from "components/base/fade-in/FadeInAnimation";
import { useParams } from "next/navigation";
import { PrematchContext } from "contexts";
import PrematchCategory from "./PrematchCategory";
import styles from "./prematch-categories-container.module.sass";

interface IProps {
    categories: ICategoryFeedResponse[];
    sportSlug: string;
    sportId: number;
    openedByDefault?: boolean;
    showTournamentCheckbox?: boolean;
    showArrow?: boolean;
}

const PrematchCategoriesContainer: ForwardRefExoticComponent<
    IProps & RefAttributes<HTMLUListElement>
> = forwardRef(
    (
        { categories, sportSlug, openedByDefault, showTournamentCheckbox, showArrow, sportId },
        ref,
    ) => {
        const params = useParams();
        const { isCategorySelected } = useContext(PrematchContext);
        // const categoryId = useSelectedPrematchCategoryId();

        const getIsOpenedByDefault = useCallback(
            (category: ICategoryFeedResponse, index: number) => {
                if (openedByDefault) {
                    return (
                        parseInt(params.categoryId as string) === category.id ||
                        isCategorySelected(category.id)
                    );
                } else {
                    return index === 0;
                }
            },
            [openedByDefault, params.categoryId, isCategorySelected],
        );

        return (
            <FadeInAnimation>
                <div
                    className={styles.categoryItemsList}
                    data-testid="sportsbook-prematch-container">
                    <ul className={styles.categoryItemsListContainer} ref={ref}>
                        {categories.map((category: ICategoryFeedResponse, index: number) => (
                            <PrematchCategory
                                key={category.id}
                                category={category}
                                openedByDefault={getIsOpenedByDefault(category, index)}
                                sportSlug={sportSlug}
                                showTournamentCheckbox={showTournamentCheckbox}
                                showArrow={showArrow}
                                sportId={sportId}
                            />
                        ))}
                    </ul>
                </div>
            </FadeInAnimation>
        );
    },
);

export default memo(PrematchCategoriesContainer);
